module.exports = __webpack_public_path__ + "media/images/front/icon_02_search_gl-d037387b49bded3c2d0dc9caa3ccf26f.png";